import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { CampaignForm } from "components/forms";

export const CampaignEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm();
  
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <CampaignForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Edit>
  );
};
